import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Navigate } from "react-router";
import { AppDispatch } from "../../data/redux/store";
import { loadUserDataThunk } from "../../data/redux/authSlice";

const requireAuthentification = (WrappedComponent: any) =>
  function AuthentificationWrapper(props: any) {
    const dispatch = useDispatch<AppDispatch>();
    const isAuth = useSelector((state: any) => state.auth.isAuthenticated);
    const isUserLoaded = useSelector((state: any) => state.auth.isUserLoaded);

    const [loadError, setLoadError] = useState(false);

    useEffect(() => {
      if (!isUserLoaded) {
        dispatch(loadUserDataThunk())
          .unwrap()
          .then((data) => {
            // console.log("User data loaded: utilisateur connecté", data.status);
          })
          .catch((error) => {
            // console.error("Échec du chargement de l'utilisateur :", error);
            setLoadError(true);
          });
      }
    }, [dispatch, isUserLoaded]);

    if (loadError) {
      return <Navigate to="/login" replace />;
    }

    if (!isUserLoaded) {
      // Tu peux mettre un loader ici
      return <div>Chargement...</div>;
    }
    if (!isAuth) {
      return <Navigate to="/login" replace />;
    }
    return <WrappedComponent {...props} />;
  };

export default requireAuthentification;
